<template>
    <div class="vote_input">
        <div class="option_title">
            <img v-if="is_required" style="width:18px;height:18px" src="../image/required.png">
            {{title}}
            <!-- {{index + 1}}. {{title}} -->
            <van-image
              width="100%"
              height="100%"
              style="margin-top: 10px;"
              v-if="img_url !== ''"
              :src="img_url"
            />
            <div class="desc">
              {{desc}}
            </div>
        </div>
        <div class="content">
            <van-field
                v-model="message"
                :rows="rows"
                autosize
                type="textarea"
                :maxlength="maxlength"
                placeholder="请输入内容"
                show-word-limit
                class="content_input"
                @input='setRadioId'
                :readonly = is_done
                />
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      rows: 1,
      maxlength: '300',
      isWrite: false,
      questionData: {
        question_id: this.question_id, //  问题ID
        is_required: this.is_required, //  是否必须 布尔值
        topic_id: this.topic_id, //  问题类型 Numeber
        title: this.title, //  问题标题
        img_url: '', // 图片
        desc: '', // 未知
        options: this.options
      }
    }
  },
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    index: {
      type: Number
    },
    is_required: {
      type: Boolean
    },
    topic_id: {
      type: Number
    },
    question_id: {
      type: Number
    },
    is_done: {
      type: Boolean
    },
    desc: {
      type: String
    },
    img_url: {
      type: String
    }
  },
  mounted () {
    this.isMakeOut()
    this.isRows()
    this.isSequired()
  },
  methods: {
    // 判断用户是否填写该问卷，若填写则返回答案
    isMakeOut () {
      if (this.is_done) {
        for (let i = 0; i < this.options.length; i++) {
          const item = this.options[i]
          if (item.answer !== '') {
            this.message = item.answer
          }
        }
      } else {
        this.message = ''
      }
    },
    // 输入后整理提交数据
    setRadioId () {
      const arr = JSON.parse(JSON.stringify(this.questionData.options)) // 完美
      arr[0].answer = this.message
      this.questionData.options = arr
    },
    // 判断是但文本题还是多文本题
    isRows () {
      if (this.topic_id === 3) {
      } else {
        this.rows = 2
        this.maxlength = 1000
      }
    },
    // 判断问卷是否为必填项
    isSequired () {
      if (!this.is_required) {
        this.isWrite = true
      } else {
        this.isWrite = false
      }
    }
  },
  // 监控填写数据
  watch: {
    message () {
      this.$nextTick(() => {
        if (this.message.trim() !== '') {
          this.isWrite = true
        } else {
          this.isSequired()
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.vote_input{
    width: 100%;
    .content_input{
        border: 1px solid rgb(224, 213, 213);
    }
}
.option_title{
    margin-bottom: 15px;
    .desc{
      font-size: 13px;
      color: dimgray;
    }
}
</style>
